export default "__VITE_ASSET__Dn5LC5hy__"